import "@app/design-system/foundations/global.css";
import { RouteManager } from "@app/route";
import { useSocketIo } from "@app/hooks";
import { HelmetContainer, BrandingColors } from "@app/shared/layout";
import { environment } from "./config/environment";

function App() {
  const { isConnected } = useSocketIo({});
  console.log({ isConnected });
  if(!environment.isDevelopment){
    console.log = ()=>{}
  }
  return (
    <div className="v2-root">
      <HelmetContainer />
      <BrandingColors />
      <RouteManager />
    </div>
  );
}

export default App;
